export const errorActionCreator = actionType => error => ({
    type: actionType,
    error,
});



// WEBPACK FOOTER //
// ./src/actions/helpers.js